<template>
  <section class="sure-info"
           v-show="isShow">
    <div class="border-out-box">
      <img src="../assets/img/icon_fail.png" />
      <p> {{ title }} </p>
      <div class="content-box"> {{ content }} </div>
      <div>
        <div class="btn-box">
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default () {
        return false
      }
    },
    title: {
      type: String,
      default () {
        return '提示'
      }
    },
    content: {
      type: String,
      default () {
        return ''
      }
    }
  },
  name: 'sure-info',
  data () {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.sure-info {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  .border-out-box {
    margin: 500px auto 0;
    width: 60%;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    font-size: 28px;
    img {
      width: 48px;
      height: 48px;
      margin-top: 25px;
    }
    p {
      font-size: 30px;
      font-family: 宋体;
      font-weight: 500;
      color: #333333;
      // border-bottom: 1px solid #ccc;
      padding: 12px 0;
    }
    .content-box {
      padding: 0px 63px;
      font-size: 26px;
      font-family: 宋体;
      font-weight: 400;
      color: #8f98a8;
      text-align: center;
    }
    .btn-box {
      div {
        // margin: 20px auto 10px;
        padding: 10px;
        height: 85px;
        line-height: 85px;
        border-radius: 5px;
        background: $themeColor;
        font-size: 26px;
        font-family: 宋体;
        font-weight: 400;
        color: #2489ff;
        text-align: center;
        border-top: 1px solid #e8ebf0;
        margin-top: 22px;
      }
    }
  }
}
</style>
